document.addEventListener("click", (e) => {
	const playButton = e.target.closest("[data-action-play-video]");
	if (!playButton) return;

	const component = playButton.closest("[data-component-shopify-video]");
	const video = component.querySelector("video");
	const youtubeFacade = component.querySelector(".youtube-facade");
	const overlay = component.querySelector("[data-video-overlay]");

	// Fade out overlay
	if (overlay) {
		overlay.classList.add("opacity-0", "pointer-events-none");
	}

	if (youtubeFacade) {
		// YouTube: Replace facade with iframe
		const videoId = youtubeFacade.dataset.youtubeId;
		const showControls = youtubeFacade.dataset.showControls === "true" ? 1 : 0;

		const iframe = document.createElement("iframe");
		iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&controls=${showControls}&rel=0&playsinline=1&enablejsapi=1`;
		iframe.className = "w-full aspect-16/9";
		iframe.frameBorder = "0";
		iframe.allow =
			"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
		iframe.allowFullscreen = true;

		youtubeFacade.innerHTML = "";
		youtubeFacade.appendChild(iframe);
	} else if (video) {
		// Shopify video: show controls and play
		video.setAttribute("controls", "controls");
		video.play();
	}
});
